import {
  AirRestrictionStatus,
  type IRestrictionProps,
} from "@b2bportal/core-types";
import DOMPurify from "dompurify";

const RESTRICTION_PREFIX = "policy_fact_";

/**
 * Extracts CFAR merchandising restrictions from the `merchandisingContents` record.
 * Filters keys matching `policy_fact_<digits>` (ignoring suffixed keys like `policy_fact_1_long`),
 * sorts by numeric suffix, sanitizes HTML, and returns as `IRestrictionProps[]`.
 */
export function extractCfarMerchandisingRestrictions(
  merchandisingContents: Record<string, string> | undefined
): IRestrictionProps[] {
  if (!merchandisingContents) {
    return [];
  }

  const pattern = new RegExp(`^${RESTRICTION_PREFIX}\\d+$`);

  return Object.entries(merchandisingContents)
    .filter(([key]) => pattern.test(key))
    .sort(([keyA], [keyB]) => {
      const numA = parseInt(keyA.replace(RESTRICTION_PREFIX, ""), 10);
      const numB = parseInt(keyB.replace(RESTRICTION_PREFIX, ""), 10);
      return numA - numB;
    })
    .map(
      ([key, value]): IRestrictionProps => ({
        // CFAR merchandising content describes benefits included with the policy,
        // so all restrictions are marked as INCLUDED. The merchandising data format
        // from the backend does not include per-item status information.
        symbol: AirRestrictionStatus.INCLUDED,
        name: key,
        description: DOMPurify.sanitize(value),
        hideName: true,
      })
    );
}
